// Simple DE/EN translation dictionary for Chalet Steiermark
export const translations = {
  de: {
    nav: {
      home: "Start",
      property: "Chalet",
      gallery: "Galerie",
      amenities: "Ausstattung",
      location: "Lage",
      reviews: "Stimmen",
      contact: "Kontakt",
      book: "Buchen",
    },
    hero: {
      eyebrow: "Steiermark · Österreich",
      title: "Ein Rückzugsort\naus Zirbenholz.",
      sub: "Ankommen. Durchatmen. Wohlfühlen. Warmes Zirbenholz, klares Design und moderner Komfort — eingebettet in die stille Schönheit der steirischen Berge.",
      cta: "Verfügbarkeit prüfen",
      scroll: "Entdecken",
      combo_banner: "Combo · Beide Häuser zusammen für bis zu 20 Gäste — 10 % Rabatt",
      combo_cta: "Combo entdecken",
    },
    widget: {
      checkin: "Anreise",
      checkout: "Abreise",
      guests: "Gäste",
      guest_singular: "Gast",
      guest_plural: "Gäste",
      pets: "Haustiere",
      pet_singular: "Haustier",
      pet_plural: "Haustiere",
      submit: "Verfügbarkeit prüfen",
      from: "Ab",
      perNight: "/ Nacht",
      total: "Gesamtpreis",
      nights: "Nächte",
      cleaning: "Endreinigung",
      pet_fee: "Haustier-Pauschale",
      subtotal: "Zwischensumme",
      checking: "Prüfe...",
    },
    intro: {
      eyebrow: "Das Zirben Chalet",
      title: "Alpiner Luxus,\nstill erzählt.",
      body: "Vier liebevoll gestaltete Schlafzimmer. Ein offener Wohnbereich mit weißem Kachelofen. Eine Küche, die zum Verweilen einlädt. 145 m² Wohnfläche für bis zu acht Gäste — gehüllt in warmes Naturholz und umgeben von steirischer Bergwelt.",
      stats: [
        { value: "145", label: "m² Wohnfläche" },
        { value: "4", label: "Schlafzimmer" },
        { value: "8", label: "Gäste" },
        { value: "2", label: "Terrassen" },
      ],
    },
    gallery: {
      eyebrow: "Bildwelten",
      title: "Räume, die\nlangsam atmen.",
      sub: "Vom verschneiten Außenbereich über das offene Wohnzimmer bis in die ruhigen Schlafzimmer unter der Dachschräge.",
    },
    rooms: {
      eyebrow: "Räume",
      title: "Vier Räume.\nVier Stimmungen.",
      list: [
        { name: "Schlafzimmer · Zirben Chalet", text: "Warmes Zirbenholz, massives Doppelbett, helle Bettwäsche und Blick ins Grüne." },
        { name: "Schlafzimmer · Landhaus", text: "Großzügiges Zimmer im Landhaus — hell, beruhigend, mit hochwertigen Massivholzmöbeln." },
        { name: "Küche · Landhaus", text: "Voll ausgestattete Küche im Landhaus — vom Frühstück bis zum Grillabend ist alles vorbereitet." },
        { name: "Kaminzimmer · Landhaus", text: "Gemütliches Kaminzimmer mit offenem Kamin — warme Abende, lange Gespräche, knisterndes Holz." },
      ],
    },
    amenities: {
      eyebrow: "Ausstattung",
      title: "Alles, was du\nbrauchst — inklusive.",
      list: [
        { icon: "wifi", text: "Highspeed WLAN" },
        { icon: "fire", text: "Kachelofen & Kamin" },
        { icon: "tv", text: "5 Flachbild-Sat-TVs" },
        { icon: "kitchen", text: "Voll ausgestattete Küche" },
        { icon: "bath", text: "2 Badezimmer mit Dusche" },
        { icon: "terrace", text: "2 Terrassen mit Grillplatz" },
        { icon: "parking", text: "Eigene Parkplätze" },
        { icon: "key", text: "Kontaktloser Self-Check-in" },
        { icon: "garden", text: "Großer Garten" },
        { icon: "camera", text: "Kameraüberwachter Außenbereich" },
      ],
    },
    location: {
      eyebrow: "Lage",
      title: "Mitten in den\nsteirischen Bergen.",
      body: "Eingebettet in Pusterwald, Steiermark — umgeben von Tannenwäldern, Obstbäumen und absoluter Ruhe. In wenigen Minuten erreichst du Highlights wie den Red Bull Ring oder die Goldwaschanlage Pusterwald.",
      nearby: "In der Nähe",
      poi: [
        { name: "Red Bull Ring", desc: "Spielberg — Höchstgeschwindigkeit trifft auf Berglandschaft." },
        { name: "Goldwaschanlage Pusterwald", desc: "Traditionelles Goldwaschen aus dem Murschotter." },
        { name: "Skigebiet Lachtal", desc: "Wintervergnügen vor der Haustür." },
      ],
    },
    reviews: {
      eyebrow: "Stimmen unserer Gäste",
      title: "„Hier beginnt\ndein perfekter Urlaubstag.“",
      list: [
        { quote: "Ein Chalet wie aus dem Bilderbuch — wir kommen jedes Jahr wieder.", author: "Marie & Stefan", origin: "Wien" },
        { quote: "Liebe zum Detail, absolute Ruhe und unfassbar gemütlich. Der Kachelofen, der Garten… einfach perfekt.", author: "Familie Berger", origin: "München" },
        { quote: "Self-Check-in funktioniert reibungslos. Die Lage und Ausstattung sind außergewöhnlich.", author: "Lukas", origin: "Hamburg" },
      ],
    },
    faq: {
      eyebrow: "Häufige Fragen",
      title: "Gut zu wissen.",
      items: [
        { q: "Wann ist Check-in und Check-out?", a: "Check-in ab 16:00 Uhr per Schlüsselsafe — den Code erhältst du am Anreisetag. Check-out bis 10:00 Uhr." },
        { q: "Wie viele Gäste passen ins Chalet?", a: "Das Zirben Chalet bietet Platz für bis zu 8 Personen in 4 Schlafzimmern mit insgesamt 6 Schlafplätzen plus 2 Tagesbetten." },
        { q: "Sind Haustiere erlaubt?", a: "Auf Anfrage. Bitte teile uns dies vor der Buchung mit." },
        { q: "Ist das WLAN wirklich kostenlos?", a: "Ja, Highspeed-WLAN ist im gesamten Haus inklusive — ohne Zusatzkosten." },
        { q: "Welche Zahlungsmethoden werden akzeptiert?", a: "Kreditkarte über Stripe — sicher und sofortige Bestätigung." },
      ],
    },
    booking: {
      title: "Deine Buchung",
      summary: "Aufenthalt",
      yourDetails: "Deine Daten",
      firstName: "Vorname",
      lastName: "Nachname",
      email: "E-Mail",
      phone: "Telefon",
      message: "Nachricht (optional)",
      submit: "Jetzt verbindlich buchen",
      cancel: "Zurück",
      processing: "Wird verarbeitet...",
      cancelled: "Buchung abgebrochen. Du kannst es erneut versuchen.",
      successTitle: "Buchung bestätigt.",
      successSub: "Vielen Dank! Eine Bestätigung wurde an deine E-Mail gesendet. Wir freuen uns auf deinen Aufenthalt im Zirben Chalet.",
      checking: "Wir prüfen deine Zahlung...",
      failedTitle: "Zahlung nicht abgeschlossen",
      failedSub: "Etwas ist schiefgelaufen. Bitte versuche es erneut oder kontaktiere uns.",
      backHome: "Zurück zur Startseite",
    },
    footer: {
      tag: "Ankommen. Durchatmen. Wohlfühlen.",
      quick: "Navigation",
      legal: "Rechtliches",
      impressum: "Impressum",
      datenschutz: "Datenschutz",
      agb: "AGB",
      contact: "Kontakt",
      rights: "Alle Rechte vorbehalten.",
    },
    admin: {
      title: "Admin-Bereich",
      login: "Anmelden",
      email: "E-Mail",
      password: "Passwort",
      logout: "Abmelden",
      dashboard: "Dashboard",
      bookings: "Buchungen",
      revenue: "Umsatz",
      noBookings: "Noch keine Buchungen.",
    },
  },
  en: {
    nav: { home: "Home", property: "Chalet", gallery: "Gallery", amenities: "Amenities", location: "Location", reviews: "Reviews", contact: "Contact", book: "Book" },
    hero: {
      eyebrow: "Styria · Austria",
      title: "A retreat carved\nfrom stone pine.",
      sub: "Arrive. Breathe. Stay. Warm Swiss pine, quiet design and modern comfort — embedded in the still beauty of the Styrian Alps.",
      cta: "Check availability",
      scroll: "Discover",
      combo_banner: "Combo · Both houses together for up to 20 guests — 10 % off",
      combo_cta: "Discover Combo",
    },
    widget: {
      checkin: "Check-in", checkout: "Check-out", guests: "Guests",
      guest_singular: "guest", guest_plural: "guests",
      pets: "Pets", pet_singular: "pet", pet_plural: "pets",
      submit: "Check availability", from: "From", perNight: "/ night",
      total: "Total", nights: "nights", cleaning: "Cleaning fee", pet_fee: "Pet fee", subtotal: "Subtotal", checking: "Checking...",
    },
    intro: {
      eyebrow: "Zirben Chalet",
      title: "Alpine luxury,\nquietly told.",
      body: "Four softly designed bedrooms. An open living area with a white tiled stove. A kitchen made to linger in. 145 m² for up to eight guests — wrapped in natural pine and Styrian mountain silence.",
      stats: [
        { value: "145", label: "m² interior" },
        { value: "4", label: "bedrooms" },
        { value: "8", label: "guests" },
        { value: "2", label: "terraces" },
      ],
    },
    gallery: { eyebrow: "Imagery", title: "Rooms that\nbreathe slowly.", sub: "From the snow-covered exterior to the open living room and the quiet bedrooms under the eaves." },
    rooms: {
      eyebrow: "Rooms", title: "Four spaces.\nFour moods.",
      list: [
        { name: "Bedroom · Zirben Chalet", text: "Warm stone-pine wood, solid double bed, light linens and a view of the surrounding pines." },
        { name: "Bedroom · Landhaus", text: "Spacious Landhaus bedroom — bright, soothing, with premium solid-wood furniture." },
        { name: "Kitchen · Landhaus", text: "Fully equipped Landhaus kitchen — from breakfast to grill night, everything is ready." },
        { name: "Fireplace Lounge · Landhaus", text: "Cozy lounge with an open fireplace — warm evenings, long talks, crackling wood." },
      ],
    },
    amenities: {
      eyebrow: "Amenities", title: "Everything you need —\nincluded.",
      list: [
        { icon: "wifi", text: "Highspeed Wi-Fi" },
        { icon: "fire", text: "Tiled stove & fireplace" },
        { icon: "tv", text: "5 Flat-screen TVs" },
        { icon: "kitchen", text: "Fully equipped kitchen" },
        { icon: "bath", text: "2 bathrooms with shower" },
        { icon: "terrace", text: "2 terraces with grill" },
        { icon: "parking", text: "Private parking" },
        { icon: "key", text: "Contactless self check-in" },
        { icon: "garden", text: "Large garden" },
        { icon: "camera", text: "CCTV outdoor area" },
      ],
    },
    location: {
      eyebrow: "Location", title: "In the heart of\nthe Styrian Alps.",
      body: "Nestled in Pusterwald, Styria — surrounded by fir forests, fruit trees and absolute stillness. Within minutes of the Red Bull Ring and the Pusterwald gold-panning site.",
      nearby: "Nearby",
      poi: [
        { name: "Red Bull Ring", desc: "Spielberg — high speed meets mountain landscape." },
        { name: "Pusterwald Gold Mine", desc: "Traditional gold panning from the Mur river gravel." },
        { name: "Lachtal Ski Resort", desc: "Winter playground right on your doorstep." },
      ],
    },
    reviews: {
      eyebrow: "Guest voices", title: "“This is where\nyour perfect day begins.”",
      list: [
        { quote: "A picture-book chalet — we come back every year.", author: "Marie & Stefan", origin: "Vienna" },
        { quote: "Love for detail, absolute calm and unbelievably cozy. The tiled stove, the garden… just perfect.", author: "The Berger family", origin: "Munich" },
        { quote: "Self check-in works flawlessly. Location and equipment are outstanding.", author: "Lukas", origin: "Hamburg" },
      ],
    },
    faq: {
      eyebrow: "Frequently asked", title: "Good to know.",
      items: [
        { q: "What are check-in and check-out times?", a: "Check-in from 4 pm via key safe — you'll receive the code on arrival day. Check-out by 10 am." },
        { q: "How many guests can stay?", a: "Up to 8 guests across 4 bedrooms with 6 beds plus 2 day beds." },
        { q: "Are pets allowed?", a: "On request. Please let us know before booking." },
        { q: "Is Wi-Fi really free?", a: "Yes — high-speed Wi-Fi is included throughout the house at no extra cost." },
        { q: "Which payment methods are accepted?", a: "Credit card via Stripe — secure and instant confirmation." },
      ],
    },
    booking: {
      title: "Your booking",
      summary: "Stay",
      yourDetails: "Your details",
      firstName: "First name", lastName: "Last name",
      email: "Email", phone: "Phone", message: "Message (optional)",
      submit: "Book now", cancel: "Back", processing: "Processing...",
      cancelled: "Booking cancelled. Feel free to try again.",
      successTitle: "Booking confirmed.",
      successSub: "Thank you! A confirmation has been sent to your email. We're looking forward to your stay at Zirben Chalet.",
      checking: "Verifying your payment...",
      failedTitle: "Payment not completed",
      failedSub: "Something went wrong. Please try again or contact us.",
      backHome: "Back to home",
    },
    footer: { tag: "Arrive. Breathe. Stay.", quick: "Navigation", legal: "Legal", impressum: "Imprint", datenschutz: "Privacy", agb: "Terms", contact: "Contact", rights: "All rights reserved." },
    admin: { title: "Admin area", login: "Sign in", email: "Email", password: "Password", logout: "Sign out", dashboard: "Dashboard", bookings: "Bookings", revenue: "Revenue", noBookings: "No bookings yet." },
  },
};

// ---- Multi-language merge: import light-weight translations for 8 more locales
// and merge them with English fallback so uncovered strings never break the UI.
import { nl, cs, hu, it, sl, pl, uk, fr, languageMeta } from "./i18n_extra";

function deepMerge(base, override) {
  if (Array.isArray(base) || Array.isArray(override)) return override ?? base;
  if (typeof base !== "object" || base === null) return override ?? base;
  const out = { ...base };
  if (override && typeof override === "object") {
    for (const k of Object.keys(override)) {
      out[k] = deepMerge(base?.[k], override[k]);
    }
  }
  return out;
}

const EN = translations.en;
Object.assign(translations, {
  nl: deepMerge(EN, nl),
  cs: deepMerge(EN, cs),
  hu: deepMerge(EN, hu),
  it: deepMerge(EN, it),
  sl: deepMerge(EN, sl),
  pl: deepMerge(EN, pl),
  uk: deepMerge(EN, uk),
  fr: deepMerge(EN, fr),
});

export { languageMeta };
